import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Navbar = () => {

  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/");           // go to home
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 50); // wait for route change
  };
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    setMenuOpen(false);

    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled
        ? 'bg-[#0B0F14]/50 border-b border-[#1F2933]'
        : 'bg-transparent'
        }`}
    >
      <div className="max-w-[90%] mx-auto px-6 py-4">

        <div className="flex items-center justify-between">

          {/* Logo
          <Link to="/" className="flex items-center">
            <img
              src="/logo.png"
              alt="The AI Kompany"
              className="h-20 w-auto"
            />
          </Link>*/}
          <div onClick={handleLogoClick} className="cursor-pointer flex items-center">
            <img src="/logo.png" alt="logo" className="h-20 w-auto" />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center flex-1 justify-end">

            <div className="relative flex items-center px-10 py-3 space-x-8 rounded-full 
  bg-white/5 backdrop-blur-xl border border-white/10 
  shadow-[0_0_30px_rgba(61,242,224,0.08)]
  
  before:absolute before:inset-0 before:rounded-full
  before:bg-gradient-to-r before:from-transparent 
  before:via-white/10 before:to-transparent 
  before:opacity-20 before:pointer-events-none">

              <button
                onClick={() => scrollToSection('services')}
                className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition font-['League_Spartan'] font-bold"
              >
                Solutions
              </button>

              <button
                onClick={() => scrollToSection('how-it-works')}
                className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition font-['League_Spartan'] font-bold"
              >
                How.We.Work
              </button>

              <button
                onClick={() => scrollToSection('case-studies')}
                className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition font-['League_Spartan'] font-bold"
              >
                Case.Studies
              </button>

              <Link
                to="/blog"
                className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition font-['League_Spartan'] font-bold"
              >
                Blog
              </Link>

              <Link
                to="/about"
                className="text-base text-[#9CA3AF] hover:text-[#3DF2E0] transition font-['League_Spartan'] font-bold"
              >
                About.Us
              </Link>

              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-[#0B0F14] text-[#3DF2E0] border border-[#3DF2E0] hover:bg-[#3DF2E0] hover:text-[#0B0F14] transition-all duration-300 rounded-full px-5 py-2 text-sm font-['Qurova']"
              >
                Book AI Consultation
              </Button>

            </div>

          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X size={30} /> : <Menu size={30} />}
          </button>

        </div>

      </div>

      {/* Mobile Menu Dropdown */}
      {menuOpen && (
        <div className="md:hidden bg-[#0B0F14] border-t border-[#1F2933] flex flex-col items-center gap-6 py-6">

          <button
            onClick={() => scrollToSection('services')}
            className="text-lg text-[#9CA3AF] hover:text-[#3DF2E0] font-['League_Spartan'] font-bold"
          >
            Services
          </button>

          <button
            onClick={() => scrollToSection('industries')}
            className="text-lg text-[#9CA3AF] hover:text-[#3DF2E0] font-['League_Spartan'] font-bold"
          >
            Industries
          </button>

          <button
            onClick={() => scrollToSection('how-it-works')}
            className="text-lg text-[#9CA3AF] hover:text-[#3DF2E0] font-['League_Spartan'] font-bold"
          >
            How It Works
          </button>

          <button
            onClick={() => scrollToSection('case-studies')}
            className="text-lg text-[#9CA3AF] hover:text-[#3DF2E0] font-['League_Spartan'] font-bold"
          >
            Case Studies
          </button>

          <Link
            to="/about"
            className="text-lg text-[#9CA3AF] hover:text-[#3DF2E0] font-['League_Spartan'] font-bold"
            onClick={() => setMenuOpen(false)}
          >
            About Us
          </Link>

          <Button
            onClick={() => scrollToSection('contact')}
            className="bg-[#0B0F14] text-[#3DF2E0] border border-[#3DF2E0] hover:bg-[#3DF2E0] hover:text-[#0B0F14] rounded-md px-6 font-['Qurova']"
          >
            Book AI Consultation
          </Button>

        </div>
      )}

    </nav>
  );
};

export default Navbar;